<script>
 
    /** @type {string} the text written by a user that should be displayed */
    export let text = '';

    /** @type {boolean} default false, 
     *                  false => text will be escaped (treated as plain text),  
     *                  true => text will be rendered as html (@html) */
    export let renderAsHtml = false;

    /** @type {string} set if you want any additional css class for the surrounding div */
    export let cssClass = '';
        
    $: cssClasses = renderAsHtml ? 'user-content-html ' + cssClass : 'user-content ' + cssClass;

    
</script>
<div class="{cssClasses}">
    {#if renderAsHtml}
        {@html text}
    {:else}
        {text}
    {/if}
</div>

